import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../data/landing";
import { useSnapCarousel } from "../hooks/useSnapCarousel";
import { CarouselDots } from "./CarouselDots";
export function Testimonials() {
  const {
    ref,
    index,
    onScroll,
    scrollTo
  } = useSnapCarousel(testimonials.length);
  return <section aria-label="Testimonios" className="bg-paper" data-id="element-305" data-mp="3azt57ofmmxjh">
      <div className="mx-auto max-w-6xl px-5 py-10 md:px-8 md:py-20" data-id="element-306" data-mp="36ypqj59bf7ju">
        <div ref={ref} onScroll={onScroll} className="no-scrollbar -mx-5 flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-px-5 px-5 md:mx-0 md:grid md:grid-cols-3 md:gap-0 md:overflow-visible md:px-0" data-id="element-307" data-mp="36wwipmmyuha9">
          {testimonials.map((t, i) => <figure key={t.name} className={`flex w-[84%] shrink-0 snap-start flex-col rounded-2xl bg-cream p-5 md:w-auto md:rounded-none md:bg-transparent md:px-8 md:py-0 ${i > 0 ? "md:border-l md:border-line" : "md:pl-0"} ${i === testimonials.length - 1 ? "md:pr-0" : ""}`} data-id="element-308" data-mp="2s3t8k0bpf5tk" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 estrellas" data-id="element-309" data-mp="m5b4hoxjxuic">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold md:h-4 md:w-4" aria-hidden data-id="element-310" data-mp="79bpduc0yu3p" data-mpi={s} />)}
              </div>
              <blockquote className="mt-3 font-display text-[17px] leading-snug text-forest md:mt-4 md:text-xl" data-id="element-311" data-mp="zwpo9xza9zqg">“{t.quote}”</blockquote>
              <figcaption className="mt-auto pt-4 text-[13px] md:pt-6 md:text-sm" data-id="element-312" data-mp="14uhiiynehxxt">
                <span className="font-semibold text-ink" data-id="element-313" data-mp="q7ej2mfipf7u">{t.name}</span>
                <span className="text-muted" data-id="element-314" data-mp="v5prqtu2tjoh"> · {t.city}</span>
                <span className="mt-0.5 block text-muted" data-id="element-315" data-mp="v3wjxb7q8tew">{t.role}</span>
              </figcaption>
            </figure>)}
        </div>
        <CarouselDots count={testimonials.length} index={index} onSelect={scrollTo} data-id="element-316" data-mp="1nlqrn6t9ekov" />
      </div>
    </section>;
}